import { getWebServiceParamName, getWebServiceValueFn } from '../conf/conf';
import appStore from '../redux/store/appStore';
import { getItem } from '../helpers/object-helper';

const getRequestDataForItems = items => {
    const appState = appStore.getState();
    const data = {};
    for(let item of items) {
        const key = webServiceParamName(item);
        const value = webServiceParamValue(item, getItem(item, appState));
        data[key] = value;
    }
    return data;
};

/**
 * Returns the http request data for http-client.validate(body) request
 * @returns {Object}
 *  .ss {String}
 */
 const validateRequestData = () => {
    const requestData = {};
    const appState = appStore.getState();
    requestData.ss = getItem('applicationContext.ss', appState);
    return requestData;
};

/**
 * Returns the payload for /sendData Web API endpoint request
 * @returns {Object}
 *  .tipo_installazione {String}
 *  .dove {String}
 *  .numero_stanze {String}
 *  .numero_clima_per_stanza_mono9 {String}
 *  .numero_clima_per_stanza_mono12 {String}
 *  .numero_clima_per_stanza_mono18 {String}
 *  .numero_clima_per_stanza_dual9_9 {String}
 *  .numero_clima_per_stanza_dual9_12 {String}
 *  .numero_clima_per_stanza_trial9_9_9 {String}
 *  .numero_clima_per_stanza_trial9_9_12 {String}
 *  .marchi {String}
 *  .nome {String}
 *  .cognome {String}
 *  .email {String}
 *  .ragioneSociale {String}
 *  .indirizzo {String}
 *  .numeroCivico {String}
 *  .comune {String}
 *  .cap {String}
 *  .provincia {String}
 *  .tipoImmobile {String}
 *  .channel {String}
 *  .solarSpecialist {String} optional
 *  .campaign {String} optional
 */
const sendDataRequestData = () => {

    let requestData = {};

    // fetch application state to populate data
    const appState = appStore.getState();

    // configuration data
    const configurationItems = [
        'configuration.tipo_installazione',
        'configuration.dove',
        'configuration.numero_stanze',
        'configuration.numero_clima_per_stanza_mono9',
        'configuration.numero_clima_per_stanza_mono12',
        'configuration.numero_clima_per_stanza_mono18',
        'configuration.numero_clima_per_stanza_dual9_9',
        'configuration.numero_clima_per_stanza_dual9_12',
        'configuration.numero_clima_per_stanza_trial9_9_9',
        'configuration.numero_clima_per_stanza_trial9_9_12',
        'configuration.marchi',
        'configuration.scarico_4mt_discesa',
        'configuration.unita_esterna_2_5mt',
        'configuration.parete_cemento_pietra',
        'configuration.quante_pareti_attraversare',
        
    ];

    // quotationsForm data
    const quotationsFormItems = [
        'quotationsForm.nome',
        'quotationsForm.cognome',
        'quotationsForm.email',
        'quotationsForm.telefono',
        'quotationsForm.ragioneSociale',
        'quotationsForm.indirizzo',
        'quotationsForm.numerocivico',
        'quotationsForm.comune',
        'quotationsForm.cap',
        'quotationsForm.provincia',
        'quotationsForm.tipoImmobile',
        'quotationsForm.emailCommerciale'
    ];

    // add configuration and quotationsForm items
    requestData = {
        ...requestData,
        ...getRequestDataForItems(configurationItems),
        ...getRequestDataForItems(quotationsFormItems)
    };

    // add applicationContext data
    requestData.channel = getItem('applicationContext.ch', appState);

    const solarSpecialist = getItem('applicationContext.ss', appState);
    if (solarSpecialist) {
        requestData.solarSpecialist = solarSpecialist;
    }

    const campaign = getItem('applicationContext.cmp', appState);
    if (campaign) {
        requestData.campaign = campaign;
    }

    // return
    return requestData;
};

/**
 * Returns the name for itemPath item when it is passed as a web service parameter
 * Result is driven by configuration (/conf/conf.js)
 * @param {String} itemPath
 *  Sample
 *      'configuration.roofArea'
 * @return {String}
 *  Sample
 *      'area'
 */
const webServiceParamName = (itemPath) => {
    const webServiceParamName = getWebServiceParamName(itemPath);
    if (webServiceParamName) {
        return webServiceParamName;
    } else {
        const itemPathElements = itemPath.split('.');
        return itemPathElements[itemPathElements.length - 1];
    }
};

/**
 * Returns the value for itemPath item when it is passed as a web service parameter
 * Result is driven by configuration (/conf/conf.js)
 * @param {String} itemPath
 *  Sample
 *      'configuration.roofTipology'
 * @param {Mixed} value
 *  Sample
 *      '1falda'
 * @return {Mixed}
 *  Sample
 *      1
 */
const webServiceParamValue = (itemPath, value) => {
    const webServiceValueFn = getWebServiceValueFn(itemPath);
    return (webServiceValueFn) ? webServiceValueFn(value) : value;
};

export {
    validateRequestData,
    sendDataRequestData
}